import React from 'react';
import { SingleBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import { useShowContext } from 'framework/show';
import { useVendorsUrl } from '../routes';
import VendorsBreadcrumbs from './VendorsBreadcrumbs';

const SingleVendorBreadcrumbs = ({ children = null }: { children?: React.ReactNode }) => {
  const { data } = useShowContext();
  const vendorName = data.getValueBySource('vendorName');
  const id = data.getValueBySource('accountId');
  const { getSingleEntityUrl } = useVendorsUrl();

  return (
    <VendorsBreadcrumbs>
      <SingleBreadcrumbItem entity={vendorName} link={getSingleEntityUrl(id)} />
      {children}
    </VendorsBreadcrumbs>
  );
};

export default SingleVendorBreadcrumbs;
